//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'MaintenanceFluidPed',
  data() {
    return {
      defaultJson:{
        "Weight": "体重",
        "IV Fluids": "静脉补液",
        "Correction factor": "校正因子"
      },
      form:{
        w:'',
        coeff:'1',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {

        // w < 10 ? (100 * w) : (w < 20 ? (1000 + (50*(w-10))) : (1500+(20*(w-20))))

        
        
        let temp_res = form.w < 10 ? (100 * form.w) : (form.w < 20 ? (1000 + (50*(form.w-10))) : (1500+(20*(form.w-20))))
        let coeff_res = form.coeff * temp_res
        let result = coeff_res > 2400 ? 2400 : coeff_res
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/MaintenanceFluidPed.vue